import React, { useEffect, useState } from "react";
import { withStyles } from "@material-ui/core";
import InputForm from "../../../components/Input/InputForm";
import { findAllMateriaisExames } from "../../../services/ExamesService";
import { observer } from "mobx-react-lite";
import { inject } from "mobx-react";
import { ReactSelect } from "../../../components/Select/SelectSearch";



const CamposExame = observer(({ classes, exameStore }) => {

  const [materiais, setMateriais] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const { exame } = exameStore || {};


  const findMaterialByExame = async (resetValues) => {
    try {
      setIsLoading(true)
      const variables = {
        exame: exameStore.exame.tipoExame.codigo
      }

      const response = await findAllMateriaisExames(variables)
      if (response.length === 1) {
        handleChange(response[0], "material")
      }
      setMateriais(response)

    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false)
    }
  }

  const handleChange = (event, field) => {
    if(field === "material" ){
      const tipoExame = exameStore.exame.tipoExame?.tipo;
      
      if(tipoExame === "PADRAO") {
        exameStore.exame.amostras = {
          descricao: event?.descricao,
          material: event?.codigo,
          exames: {
            codigo: exameStore.exame.tipoExame.codigo
          }
        };
      } else {
        exameStore.exame.amostras = [];
      }
    
      exameStore.changeDadosExame(event, "material");
    }
    if (field === "quantidadeAmostras") {
      const { exame } = exameStore;

      const tipoExameAtual = exame?.tipoExame || {};

      const tipoExameAtualizado = {
        ...tipoExameAtual,
        quantidadeAmostras: event,
      };

      exameStore.changeDadosExame(tipoExameAtualizado, "quantidadeAmostras");
    } else {
      
      exameStore.changeDadosExame(event, field);
    }
  }

  useEffect(() => {

    findMaterialByExame({ resetValues: true })

  }, [exame?.tipoExame?.codigo])

  return (
    <div className={classes.content}>
      <div className={classes.selectMateriais}>
        <label className={classes.label}>Material:</label>
        <ReactSelect
          placeholder='Selecione'
          options={materiais}
          getOptionLabel={option => option?.descricao}
          getOptionValue={option => option?.codigo}
          value={exame?.material}
          onChange={e => handleChange(e, 'material')}
          isDisabled={!exame?.tipoExame || isLoading}
          isCleareable
          isLoading={isLoading}
        />
      </div>
      <div>
        <label className={classes.label}>Qtd. Amostras:</label>
        <InputForm
          type="number" classes={{ input: classes.input }}
          onChange={e => handleChange(e?.target?.value, 'quantidadeAmostras')}
          value={exameStore?.exame?.tipoExame?.quantidadeAmostras || 0 }
          disabled={true}
        />
      </div>
      <div>
        <label className={classes.label}>Acondicionamento:</label>
        <InputForm
         disabled={true} 
         classes={{ input: classes.input }} 
         value={exameStore?.exame?.tipoExame?.acondicionamento || ""}
         />
      </div>
      <div>
        <label className={classes.label}>Prazo de execução:</label>
        <InputForm 
        disabled={true} 
        classes={{ input: classes.input }} 
        value={exameStore?.exame?.tipoExame?.prazo}
        />
      </div>
      <div>
        <label className={classes.label}>Volume Mínimo:</label>
        <InputForm 
        disabled={true} 
        classes={{ input: classes.input }}
        value={exameStore?.exame?.tipoExame?.volumeMinimo }
        />
      </div>
    </div>
  );
});

const styles = {
  content: {
    display: "grid",
    gridTemplateColumns: "2fr 0.7fr 1fr 1fr 1fr",
    gap: "9px",
    alignItems: "end",
    paddingTop: "10px",
  },
  input: {
    background: "#f2f2f2",
    border: "none",
    paddingTop: "6px !important",
    color: "#505050",
  },
  label: {
    fontSize: "10px",
    color: "#868686",
  },
  selectMateriais: {
    display: "flex",
    flexDirection: 'column'
  }
};

const CamposExameWithStyles = withStyles(styles)(CamposExame);
const stores = ["exameStore"]
export default inject(...stores)(CamposExameWithStyles)
